import type { FaireProductEntity } from "../../entity_types/product";

export const p_6qkpp7ngym: FaireProductEntity = {
  token: "p_6qkpp7ngym",
  type: "product",
  name: "Silver Anadara Ring- Astoria",
  brandToken: "b_592svxunwb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/ecbcd0121a5c586ebd6969fa2bde5f9aac235ef5cfb91a696211c42748590a3c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2f6a6cfca9c35903fce83036654b7486fee5a77bd1302c207bb3e1ff77100b19.jpeg",
    "https://cdn.faire.com/fastly/2d9839fcc0180f011a100d2c25d80cb1419ba77d8aa189471e9fbb35d9149713.jpeg",
  ],
  priceDollars: 90.62,
  description:
    "Sterling silver ring featuring an anadara fossil with a filagree band. \n\nSize: \nRing Size: 9 \nAnadara Size: 24mm x 21mm \nBand Width: 10mm\n\nMaterial: \nanadara fossil, sterling silver",
  tags: [],
  msrpDollars: 181.23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:33.606Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
